import { useState } from "react";
import { useStaffAuthContext  } from "./useStaffAuthContext";
import API_URL from '../../api/API'
import { Link,useNavigate } from "react-router-dom";



export const useStaffLogin = () =>{

    const navigate = useNavigate();

    const [error,setError] = useState(null);
    const [isLoading,setIsLoading] = useState(null);
    const {dispatch} = useStaffAuthContext();

    const staffLogin = async (email,password) => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch(API_URL.POST_STAFF_LOGIN,{
                method: 'POST',
                headers: {'Content-Type' : 'application/json'},
                body: JSON.stringify({email,password})
            });
    
            const json = await response.json();
    
            if(!response.ok){
                setIsLoading(false);
                setError(json.error);
            }
    
            if(response.ok){
                //save the user to the local storage
                localStorage.setItem('staff',JSON.stringify(json));
                dispatch({type:'STAFF_LOGIN',payload:json});
                setIsLoading(false);
                navigate('/administrator/dashboard');

            }
        } catch (error) {
            setError(error.message);
            setIsLoading(false);
        }

        
    }

    return {staffLogin, isLoading, error};
}